import { render, staticRenderFns } from "./technical_features.vue?vue&type=template&id=725ba1b2&"
import script from "./technical_features.vue?vue&type=script&lang=js&"
export * from "./technical_features.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports